import type { EventTableKind } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { type FormStatus, idleForm, idleLoad, type LoadStatus } from "../../../../core/primitives/load-status";
import {
  EMPTY_TABLE_KIND,
  type TableKindDraft,
  type TableKindErrors,
  type TableKindField,
} from "../../../../core/primitives/table-kind";

/** The kinds of table a saved show sells, and the forms that add and change them. */
export class TableKindsSectionState {
  readonly status = new Rx<LoadStatus>(idleLoad);
  readonly kinds = new RxList<EventTableKind>();

  readonly draft = new Rx<TableKindDraft>(EMPTY_TABLE_KIND);
  readonly errors = new Rx<TableKindErrors>({});
  readonly addForm = new Rx<FormStatus>(idleForm);

  readonly editingId = new Rx<string | null>(null);
  readonly editDraft = new Rx<TableKindDraft>(EMPTY_TABLE_KIND);
  readonly editErrors = new Rx<TableKindErrors>({});
  readonly editForm = new Rx<FormStatus>(idleForm);

  /** A removal in flight, and the sentence when one is refused. */
  readonly removingId = new Rx<string | null>(null);
  readonly removeError = new Rx<string | null>(null);

  /** The show is cancelled: its tables stay as they are. */
  readonly cancelled = new Rx(false);
  /** A taken table the host is asked to confirm taking back, one being taken back, and why one was not. */
  readonly confirmRefundId = new Rx<string | null>(null);
  readonly refundingId = new Rx<string | null>(null);
  readonly refundError = new Rx<string | null>(null);
}

export abstract class TableKindsSectionActions {
  abstract setField(field: TableKindField, value: string): void;
  abstract add(): Promise<void>;
  abstract startEdit(kindId: string): void;
  abstract setEditField(field: TableKindField, value: string): void;
  abstract saveEdit(): Promise<void>;
  abstract cancelEdit(): void;
  abstract remove(kindId: string): Promise<void>;
  /** The first call asks to confirm; the second refunds the shop and puts the table back on sale. */
  abstract takeBack(tableId: string): Promise<void>;
  abstract keepTable(): void;
}
